import { OBSTACLE_SUBTYPE, OBSTACLE_TYPE } from "./../ENUM.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const REDDD = {
  isDark: true,
  startHealth: 50,
  timeAllowedSecs: 130,
  textColor: "#ffff00",
  textColorHighlight: "#ff9999",
  bgColor: "#bb0000",
  bgFadeAlpha: 0.4,
  gameplayAreaToCanvasLateralRatio: 0.8,
  controllerSpeedDamp: 40,
  tip: "MAINTAIN ORDER...",
  player: {
    color: "#ffffff",
    growthDivisor: 300,
    radius: 15,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 200,
      color_ar: ["#ffcccc", "#eecccc", "#ddcccc"],
      radiusRange: [1, 3],
      directionRange: [175, 185],
      speedRange: [0.001, 0.03],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      total: 70,
      color_ar: ["#ff8888"],
      radiusRange: [11, 13],
      directionRange: [120, 240],
      speedRange: [1, 3],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      total: 100,
      color_ar: ["#FFBF00", "#FFEA00", "#FAFA33"],
      radiusRange: [20, 30],
      directionRange: [120, 240],
      speedRange: [1, 3],
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 7,
      color_ar: ["#220000"],
      radiusRange: [50, 70],
      directionRange: [180, 180],
      speedRange: [1, 2],
      numAppendagesRange: [5, 5],
      rotationSpeedRange: [1, 2],
      shapeCenterRadiusDivisor: 10,
      shapeCenterColor_ar: ["#ff2200"],
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 13,
      color_ar: ["#000000"],
      radiusRange: [20, 25],
      directionRange: [180, 180],
      speedRange: [2, 3],
      numAppendagesRange: [3, 3],
      rotationSpeedRange: [0.06, 0.09],
      shapeCenterRadiusDivisor: 3,
      shapeCenterColor_ar: ["#440000"],
    },
  ],
};
